import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const testimonials = [
  {
    name: "Mr. J.B Yadav",
    role: "Founder & CEO",
    text: "With decades of expertise in finance, business strategy, and operational excellence, J.B. Yadav brings a results-driven approach to talent acquisition. His deep understanding of corporate structures and fiscal management ensures that every HR and recruitment solution we deliver is not only efficient but also aligned with long-term business growth.",
    img: "assets/img/all-images/testimonial/jay_sir_01.jpg",
  },
  {
    name: "Mr. Dhyey Mehta ",
    role: "Director & Co- Founder",
    text: "A seasoned professional in mass communication and journalism, Dhyay Mehta combines storytelling, branding, and people-centric communication to build impactful corporate relationships. His expertise in understanding market trends, workforce culture, and employer branding enables JBY Talent Acquisition to connect the right talent with the right organizations, seamlessly.",
    img: "assets/img/all-images/testimonial/dhyey_sir.png",
  },

];

const Quotes = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <div className="testimonial10 sp1">
      <div className="container">
        {/* Header Row */}
        <div className="row align-items-center space-margin60">
          <div className="col-lg-12">
          <section class="management-section">
            <div class="management-container">
              <h2>Management Team</h2>
          
            </div>
          </section>
          </div>
          <div className="col-lg-4"></div>
          <div className="col-lg-3">
            <div className="space20 d-lg-none d-block"></div>
          
          </div>
        </div>

        {/* Slider with both image + content */}
        <Slider {...settings}>
          {testimonials.map((t, index) => (
            <div key={index} className="testimonial-slide">
              <div className="row align-items-center">
                {/* Left Side Image */}
                <div className="col-lg-5">
                  <div className="testimonial7-images">
                    
                    <div className="img1">
                      <img
                        src={t.img}
                        alt={t.name}
                        style={{ width: "100%"}}
                      />
                    </div>
                  </div>
                </div>

                {/* Right Side Content */}
                <div className="col-lg-7">
                  <div className="testimonial7-contetnt-area">
                    <div className="testimonial7-boxarea">
                      <div className="testimonial7-conetent">
                       
                        <div className="spacve12"></div>
                        <p className="pera">“{t.text}”</p>
                        <div className="space32"></div>
                        <div className="images-area">
                          <div className="img1">
                            <img src={t.img} alt={t.name} />
                          </div>
                          <div className="text">
                            <Link to="/Clients_zone">{t.name}</Link>
                            <div className="space10"></div>
                            <p>{t.role}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
       <div className="space70"></div>
    </div>
  );
};

export default Quotes;
